export const BASE_API_URL = "https://api.chucknorris.io/jokes";